export enum TpPedido {
    PedidoParaEntregar = 0,
    PedidoRaraRetirar = 1,
    PedidoDeMesa = 2,
}